import { render, staticRenderFns } from "./kflist.vue?vue&type=template&id=2035faae&scoped=true&"
import script from "./kflist.vue?vue&type=script&lang=ts&"
export * from "./kflist.vue?vue&type=script&lang=ts&"
import style0 from "./kflist.vue?vue&type=style&index=0&id=2035faae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2035faae",
  null
  
)

export default component.exports